var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolumeNoSoundMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5859375,2c-0.6357422,0-1.2578125,0.2578125-1.7070312,0.7070312L12.5859375,14H3c-1.6542969,0-3,1.3457031-3,3v14 c0,1.6542969,1.3457031,3,3,3h9.5859375l11.2929688,11.2929688C24.328125,45.7421875,24.9501953,46,25.5859375,46 C26.9169922,46,28,44.9169922,28,43.5859375V4.4140625C28,3.0830078,26.9169922,2,25.5859375,2z M26,43.5859375 c0,0.3378906-0.4697266,0.53125-0.7070312,0.2929688L13.7070312,32.2929688C13.5195312,32.1054688,13.265625,32,13,32H3 c-0.5517578,0-1-0.4482422-1-1V17c0-0.5517578,0.4482422-1,1-1h10c0.265625,0,0.5195312-0.1054688,0.7070312-0.2929688 L25.2929688,4.1210938C25.5302734,3.8828125,26,4.0761719,26,4.4140625V43.5859375z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeNoSoundMedium);
export default __webpack_public_path__ + "static/media/volume-no-sound--medium.c683c1824faea55ecccf0023ccabef8a.svg";
export { ForwardRef as ReactComponent };